import type { IChatMessage } from '@/apiClient/types/chat'

/** Last assistant row in the list that has no `id` yet (stream placeholder). */
export function findLastAssistantMessageWithoutId(
  messages: IChatMessage[],
): IChatMessage | undefined {
  return [...messages]
    .reverse()
    .find((message) => message.role === 'assistant' && !message.id)
}

/**
 * Whether we should append an empty assistant bubble so `processing_meta` can render
 * before the first `message_chunk`.
 */
export function shouldAppendPipelineProvisionalAssistant(
  messages: IChatMessage[],
  streamActive: boolean,
): boolean {
  if (!streamActive) return false
  if (findLastAssistantMessageWithoutId(messages)) return false
  const lastMessage = messages[messages.length - 1]
  return lastMessage?.role === 'user'
}

export function createProvisionalAssistantMessage(
  model: string,
  timestampSec: number,
): IChatMessage {
  return {
    role: 'assistant',
    content: '',
    model,
    timestamp: timestampSec,
  }
}
